// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.small-font[data-v-35c3b026] {\n\tfont-size: 15px;\n}\n.have-sub-menu[data-v-35c3b026]:hover:has(.v-list-item:hover)::before {\n\topacity: 0 !important;\n}\n.v-list-item[data-v-35c3b026] {\n\tmargin-bottom: 0 !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
